<template>
  <v-container>
    <v-row class="padding-20">
      <v-col cols="12">
        <v-card>
          <v-card-title>Requests</v-card-title>
          <v-list three-line>
            <v-row wrap>
              <template v-for="column in columns">
                <v-col :key="column">
                  <v-subheader>{{ column }}</v-subheader>
                </v-col>
              </template>
            </v-row>
            <template v-for="member in requests">
              <v-list-item :key="member.id">
                <v-row wrap>
                  <v-col>{{ member.name }}</v-col>
                  <v-col>{{ member.boardMember }}</v-col>
                  <v-col>{{ member.towingCompany }}</v-col>
                  <v-col>{{ member.propertyManager }}</v-col>
                  <v-col cols="2">
                    <v-btn icon color="primary" @click="approveMember(member)">
                      <v-icon>check</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="2">
                    <v-btn icon color="error" @click="rejectMember(member)">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-card-title>Admins</v-card-title>
          <v-list three-line>
            <v-row class="padding-20">
              <template v-for="column in columns">
                <v-col :key="column">
                  <v-subheader>{{ column }}</v-subheader>
                </v-col>
              </template>
            </v-row>
            <template v-for="member in verifiedAdmins">
              <v-list-item :key="member.id">
                <v-row wrap style="padding-right: 30px">
                  <v-col>{{ member.name }}</v-col>
                  <v-col>{{ member.boardMember }}</v-col>
                  <v-col>{{ member.towingCompany }}</v-col>
                  <v-col>{{ member.propertyManager }}</v-col>
                  <v-col cols="2">
                    <v-btn icon color="primary" @click="approveMember(member)">
                      <v-icon>check</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="2">
                    <v-btn icon color="error" @click="rejectMember(member)">
                      <v-icon>close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-list-item>
            </template>
          </v-list>
        </v-card>
      </v-col>
      <v-snackbar
        v-model="snackbar"
        color="primary lighten-3"
        :timeout="3000"
        light
        top
      >
        <v-avatar icon>
          <v-icon color="white" small>check</v-icon>
        </v-avatar>
        {{ message }}
      </v-snackbar>
    </v-row>
  </v-container>
</template>

<script>
import { firebaseApp } from "../../firebaseApp";
export default {
  data: () => ({
    admins: [],
    verifiedAdmins: [],
    requests: [],
    columns: [
      "Member",
      "Board",
      "Towing",
      "Property Manager",
      "Approve",
      "Reject",
    ],
    snackbar: false,
    message: "",
  }),
  methods: {
    approveMember(member) {
      firebaseApp
        .database()
        .ref("/admins/" + member.id + "/superVerified")
        .set(true)
        .then(
          (this.snackbar = true),
          (this.message = member.name + " was approved"),
          this.verifiedAdmins.push(member),
          this.removeRequestFromList(member)
        );
    },
    removeRequestFromList(member) {
      let requests = this.requests;
      for (var i = 0; i < requests; i++) {
        if (requests[i].id == member.id) {
          requests.splice(i, 1);
        }
      }
      this.requests = requests;
    },
    rejectMember(member) {
      firebaseApp
        .database()
        .ref("/admins/" + member.id)
        .remove()
        .then(
          (this.snackbar = true),
          (this.message = member.name + " was deleted")
        );
    },
    loadAdmins() {
      if (!this.admins.length) this.admins = this.$store.state.admins;
      let adminRequests = [],
        verifiedAdmins = [];
      this.admins.forEach((admin) => {
        if (!admin.superVerified) {
          adminRequests.push(admin);
        } else if (admin.superVerified) {
          verifiedAdmins.push(admin);
        }
      });
      this.requests = adminRequests;
      this.verifiedAdmins = verifiedAdmins;
    },
  },
  mounted() {
    this.loadAdmins();
  },
};
</script>